import React, {type PropsWithChildren, useCallback, useState} from "react";

import {PageChangingCallback, PageChangingContext} from "./page-changing-context";

type PageChangingContextProviderProps = PropsWithChildren<{}>;

export const PageChangingContextProvider = ({children}: PageChangingContextProviderProps) => {
    const [listeners] = useState(() => new Set<PageChangingCallback>());

    const notify = useCallback(() => {
        listeners.forEach((callback) => callback());
    }, [listeners]);

    const listen = useCallback(
        (listener: PageChangingCallback) => {
            listeners.add(listener);
            return () => listeners.delete(listener);
        },
        [listeners],
    );

    return (
        <PageChangingContext.Provider value={{notify, listen}}>
            {children}
        </PageChangingContext.Provider>
    );
};
